<template>
  <v-flex v-if="dialog" fullscreen hide-overlay transition="none" style="overflow-x: hidden;">
    <v-card>
      <!-- <Spinner ref="spinner"></Spinner> -->
      <div class="mb-4">
        <zigZag></zigZag>
      </div>
      <v-layout text-xs-center mt-5>
        <v-flex mb-0 xs12 mx-2>
          <v-layout justify-start row mx-3 mt-0 align-center>
            <v-flex>
              <v-layout row>
                <v-icon class="mr-2">fa-plus-circle</v-icon>
                <div
                  class="text-xs-left"
                  style="font-size: 20px; font-weight: 600;"
                >{{formType=='new'?"Create New ": formType=='add'?"Add ":"Edit "}} 
                Release Note {{formType=='new'?"": " - v" +releaseNote.Version}}</div>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout row>
                <v-flex>
                  <v-layout class="buttons mb-0 mr-0" justify-end row>
                    <v-btn icon @click="cancel" class="pa-0 mr-0">
                      <v-icon>fa-times</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-flex mb-3 xs12 mx-2>
            <v-form v-model="valid" @submit="editReleaseNote" ref="editReleaseNoteForm">
              <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2 class="fill-height">
                <v-layout hide-details justify-start row mt-0 mb-0 class="fill-height">
                  <v-flex hide-details mx-4 xs3 class="fill-height">
                    <v-layout row fill-height align-center>
                      <v-flex class="align-center" xs4><v-label>Version #:</v-label></v-flex>
                      <v-flex class="xs2">
                        <v-text-field
                          :items="ddlCategory"
                          v-model="releaseNote.Major"
                          label="Major #*"
                          required
                          :readonly="formType!=='new'?true:false"
                          :rules="requiredRules"
                          tabindex="0"
                        ></v-text-field>
                      </v-flex>
                      <v-flex class="align-end headline-2 font-weight-bold text-xs-center xs1">.</v-flex>
                      <v-flex class="xs2">
                        <v-text-field
                          :items="ddlCategory"
                          v-model="releaseNote.Minor"
                          label="Minor #*"
                          :readonly="formType!=='new'?true:false"
                          required
                          :rules="requiredRules"
                          tabindex="0"
                        ></v-text-field>
                      </v-flex>
                      <v-flex class="align-end headline-2 font-weight-bold text-xs-center xs1">.</v-flex>
                      <v-flex class="xs2">
                        <v-text-field
                          :items="ddlCategory"
                          v-model="releaseNote.Subminor"
                          :readonly="formType!=='new'?true:false"
                          label="Rev #*"
                          required
                          :rules="requiredRules"
                          tabindex="0"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <!-- <v-flex hide-details mx-4 xs3>
                    <v-autocomplete
                      :items="ddlCategory"
                      v-model="releaseNote.CategoryId"
                      item-text="Text"
                      item-value="Value"
                      label="Category*"
                      required
                      :rules="requiredRules"
                      tabindex="0"
                    ></v-autocomplete>
                  </v-flex>-->

                  <v-flex mx-4 xs2>
                    <v-text-field
                      v-model="releaseNote.Module"
                      label="Module*"
                      :rules="requiredRules"
                      tabindex="2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex mx-4 xs4>
                    <v-text-field
                      v-model="releaseNote.Notes"
                      label="Notes*"
                      :rules="requiredRules"
                      tabindex="2"
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-flex hide-details mx-4 xs2>
                    <v-autocomplete
                      :items="ddlStatus"
                      v-model="releaseNote.IsEnabled"
                      item-text="Text"
                      item-value="Value"
                      label="Status*"
                      required
                      :rules="requiredRules"
                      tabindex="1"
                    >
                    <template slot="selection" slot-scope="data">
                      <v-layout row>
                        <v-flex
                          :class="{'green--text': data.item.Value === 'true', 'red--text': data.item.Value === 'false'}"
                        >{{ data.item.Text }}</v-flex>
                      </v-layout>
                    </template>
                    <template slot="item" slot-scope="data">
                      <v-layout row>
                        <v-flex
                        :class="{'green--text': data.item.Value === 'true', 'red--text': data.item.Value === 'false'}"
                        >{{ data.item.Text }}</v-flex>
                      </v-layout>
                    </template>
                    </v-autocomplete>
                  </v-flex>-->

                  <v-flex mx-4 xs1>
                    <!-- <v-btn
                      color="success"
                      @click="createReleaseNote"
                      class="ml-2 mr-4"
                      v-if="formType=='new'"
                      tabindex="4"
                    >Create New</v-btn>-->
                    <v-btn
                      color="success"
                      @click="editReleaseNote"
                      class="ml-2 mr-4"
                      tabindex="4"
                    >{{formType=='new'? 'Create New': formType=='add'? 'Add Release Note': 'Update Release Note'}}</v-btn>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-form>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import Spinner from "../../components/Spinner.vue";
import axios from "axios";
import Bus from "../../bus";
import moment from "moment";
import zigZag from "../../components/ZigZag";

export default {
  name: "EditReleaseNotesManagement",

  components: {
    Spinner,
    zigZag
  },

  data: () => ({
    dialog: false,
    valid: true,

    formType: null,

    resolve: null,
    reject: null,

    releaseNote: {},

    ddlCategory: [],
    ddlStatus: [],

    requiredRules: [v => !!v || "Required"]
  }),
  computed: {
    currentDate() {
      return moment()
        .format("YYYY-MM-DD")
        .toString();
    }
  },

  mounted() {
    this.initialize();
  },

  methods: {
    initialize() {
      // this.getDropdownOptions("api/Account/GetEditAccountDdls", "ddlAccountTypes")
    },

    // Get data for elements in component from response data props
    async getElementData(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },

    // Get data for props of elements
    async getPropData(url, obj, prop) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`][`${prop}`] = resp.data))
        .catch(err => console.log(err));
    },

    // Get data for elements in component from response data
    async getResponseData(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data))
        .catch(err => console.log(err));
    },
    async open(item) {
      this.releaseNote = await Object.assign({}, item);
      this.formType = "new";
      this.dialog = true;
      this.getDropDownLists();
      
      this.$emit("parentScroll");
    },
    async openEdit(item) {
      this.dialog = await true;
      this.releaseNote = await Object.assign({}, item);
      this.formType = "edit";
      this.getDropDownLists();

      this.$emit("parentScroll");
    },
    async openAdd(item) {
      this.dialog = await true;
      this.releaseNote = await Object.assign({}, item);
      this.formType = "add";
      this.getDropDownLists();

      this.$emit("parentScroll");
    },
    async getDropDownLists() {
      axios.get("/api/Report/GetAdminEditReportDDLs").then(res => {
        this.ddlCategory = res.data.ddlCategory;
        this.ddlStatus = res.data.ddlStatus;
      });
    },

    async editReleaseNote() {
      if (this.$refs.editReleaseNoteForm.validate()) {
        if (this.formType == "add"){
          var result = await axios
          .post(
            "api/ReleaseNotes/AddReleaseNoteDetail/",
            this.releaseNote
          )
          .then(res => {
            Bus.$emit("alert", {
              color: "success",
              message: "Release Note Added Successfully"
            });
            this.$emit("parentRefresh");
            this.releaseNote.Notes =""
            this.releaseNote.Module=""
            
          })
          .catch(err => {
            console.log(err);
          });

        }
        if (this.formType == "new"){
          // var result = await axios
          // .post(
          //   "api/Report/EditReport/",
          //   this.report
          // )
          // .then(res => {
          //   //   this.report = {batchId: batchId, typeId:typeId, type: type}
          //   // this.formType="new"
          //   Bus.$emit("alert", {
          //     color: "success",
          //     message: "Report Updated Successfully"
          //   });
          //   this.close()
          // })
          // .catch(err => {
          //   console.log(err);
          // });
        }
      }
    },

    cancel() {
      (this.releaseNote = {}), (this.dialog = false);
      // this.resolve(false)
      // this.resetFormFilters()
      this.$emit("parentInitSelectedRow");
    },
    close() {
      (this.releaseNote = {}), (this.dialog = false);
      // this.resolve(item)
      // this.$root.$emit("initialize", this.initialize);
      this.$emit("parentRefresh");
      this.$emit("parentInitSelectedRow");
    },
    isOpen() {
      return this.dialog;
    }
  },
  filters: {
    formatDateTime: function(date) {
      if (
        moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()
      ) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").format(
          "YYYY/MM/DD h:mm:ss A"
        );
      }
    }
  }
};
</script>

<style scoped>
.buttons-bottom {
  position: fixed;
  bottom: 40px;
  right: 500px;
}
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
</style>

